if (!customElements.get('fs-sticky-buy')) {
  customElements.define('fs-sticky-buy', class extends HTMLElement {
    connectedCallback() {
      this.main = document.querySelector('[id^="ProductInfo-"]');
      this.target = this.main?.querySelector('.product-form__buttons');
      if (!this.target || !('IntersectionObserver' in window)) return;
      this.onClick = () => {
        if (this.dataset.directAdd === 'true') {
          const submit = this.main.querySelector('.product-form__submit');
          if (submit && !submit.disabled && submit.getAttribute('aria-disabled') !== 'true') {
            submit.click();
            this.sync();
          }
          return;
        }
        const picker = this.main.querySelector('variant-selects') || this.main;
        picker.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block:'start'});
        const control = picker.querySelector('select, input[type="radio"]:checked, button');
        control?.focus({preventScroll:true});
      };
      this.querySelector('button')?.addEventListener('click',this.onClick);
      this.sync = () => {
        const sale = this.main.querySelector('.price--on-sale .price-item--sale');
        const regular = this.main.querySelector('.price__regular .price-item--regular');
        const price = (sale || regular)?.textContent.trim() || '';
        const picker = this.main.querySelector('variant-selects');
        const choices = picker ? Array.from(picker.querySelectorAll('select, fieldset input:checked')).map(control => control.tagName === 'SELECT' ? control.selectedOptions[0]?.textContent.trim() : control.value).filter(Boolean) : [];
        const label = this.querySelector('[data-sticky-choice]');
        const options = this.querySelector('[data-sticky-options]');
        if (label) label.textContent = price;
        if (options) options.textContent = choices.join(' · ');
        if (this.dataset.directAdd === 'true') {
          const submit = this.main.querySelector('.product-form__submit');
          const button = this.querySelector('button');
          const busy = submit?.classList.contains('loading') || false;
          if (button) {
            button.disabled = !submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true';
            button.setAttribute('aria-busy', String(busy));
            const buttonLabel = button.querySelector('[data-sticky-button-label]') || button;
            buttonLabel.textContent = busy ? this.dataset.addingLabel : submit?.querySelector('span')?.textContent.trim() || this.dataset.addLabel;
          }
          const error = this.main.querySelector('.product-form__error-message-wrapper');
          const status = this.querySelector('[data-sticky-status]');
          if (status) status.textContent = error && !error.hidden ? error.querySelector('.product-form__error-message')?.textContent.trim() || '' : '';
        }
      };
      this.observer = new IntersectionObserver(([entry]) => {
        this.hidden = entry.isIntersecting || (entry.boundingClientRect.bottom > 0 && !matchMedia('(max-width: 749px)').matches);
      });
      this.observer.observe(this.target);
      this.variantObserver = new MutationObserver(this.sync);
      this.variantObserver.observe(this.main,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['disabled','aria-disabled','hidden','class']});
      this.sync();
    }
    disconnectedCallback() {
      this.observer?.disconnect(); this.variantObserver?.disconnect();
      this.querySelector('button')?.removeEventListener('click',this.onClick);
    }
  });
}
{
  const openProductDisclosure = (hash) => {
    if (!['#PawDetails', '#ProductFit', '#ProductDelivery', '#PawReturns', '#FurSwiftReviews'].includes(hash)) return;
    const target = document.getElementById(hash.slice(1));
    const disclosure = target?.tagName === 'DETAILS' ? target : target?.querySelector('details');
    if (disclosure) disclosure.open = true;
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link || link.origin !== location.origin || link.pathname !== location.pathname || link.search !== location.search) return;
    openProductDisclosure(link.hash);
  });
  window.addEventListener('hashchange', () => openProductDisclosure(location.hash));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => openProductDisclosure(location.hash), {once:true});
  } else {
    openProductDisclosure(location.hash);
  }
}
